export default "__VITE_ASSET__FMHHcHY8__"